import React, { useEffect, useRef } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';

import s from './TypeInInputBox.scss';
import classNames from 'classnames';
import { IAnswerOption, AnswerOptionStatus } from '../../../../api/private/learn-engine-api/learn-engine-api.interface';

export interface ITypeInInputBoxProps {
    option: IAnswerOption;
    onInputChange: (text: string) => void;
    maxLength: number;
    disabled?: boolean;
    shouldFocus?: boolean;
    isCode?: boolean;
}

export const TypeInInputBox = React.memo(
    ({
        option,
        onInputChange,
        maxLength,
        disabled,
        shouldFocus,
        isCode,
    }: ITypeInInputBoxProps): JSX.Element => {
        useStyles(s);
        const inputRef = useRef<HTMLInputElement>(null);

        useEffect(() => {
            if (inputRef.current && shouldFocus) {
                inputRef.current.focus();
            }
        }, []);

        return option ? (
            <input
                ref={inputRef}
                type="text"
                className={classNames('sl-type-in-input', option.status, {
                    code: isCode,
                })}
                sl-test-data="cmpTypeInInputBox"
                maxLength={maxLength}
                style={{
                    width: `${option.text.length + 2}ch`,
                }}
                value={option.text}
                onChange={(e) => onInputChange(e.target.value)}
                disabled={
                    disabled ||
                    option?.status === AnswerOptionStatus.Incorrect ||
                    option?.status === AnswerOptionStatus.Correct
                }
            />
        ) : null;
    }
);
